/**
 * Format byte size into human-readable string.
 * @param bytes - Size in bytes
 * @param fallback - Text to show when bytes is null/undefined (default: "Unknown")
 */
export function formatFileSize(
  bytes: number | null | undefined,
  fallback = "Unknown"
): string {
  if (!bytes) return fallback;
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

/**
 * Format expiry date as a full date string.
 * Used in admin context where exact date matters.
 */
export function formatExpiryDate(expiresAt: string | null | undefined): string {
  if (!expiresAt) return "Unknown";
  const date = new Date(expiresAt);
  return date.toLocaleDateString(undefined, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

/**
 * Format expiry date as relative time (e.g., "Expires in 3 days").
 * Used in public context where urgency matters.
 */
export function formatExpiryRelative(expiresAt: string | null | undefined): string {
  if (!expiresAt) return "";
  const date = new Date(expiresAt);
  const now = new Date();
  const diffMs = date.getTime() - now.getTime();
  const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) return "Expires today";
  if (diffDays === 1) return "Expires tomorrow";
  return `Expires in ${diffDays} days`;
}
